import React, { useState, useEffect } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import moment from 'moment'
import numeral from 'numeral'
import {
  Div, P, Input, H4, Icon, Button, InputWithLabel,
} from 'konsys-ui'
import {
  DatePicker, Select, Row, Col, Modal, message, Collapse,
} from 'antd'
import { REMOVE_SHIPPING_ORDER_FROM_INVOICE, UPDATE_INVOICE_PAYMENT } from '../../../constants/graphql/mutation'
import { theme } from '../../../styles/_variables'
import { checkFloat } from '../../../utils/util-services'
import PERMISSION from '../../../constants/permissions'
import { PDRBankList, TRSBankList } from '../constants'
import {
  MethodButton, EachInput, DatePicker as DP, TaxSelect,
} from '../../../components/invoice-components/styled'

const { color } = theme

const { Panel } = Collapse

export const EditPaymentModal = ({
  payment, setPayment, paymentModal, setPaymentModal, doAction, loading, invoice,
}) => {
  const [mutationVariables, setMutationVariables] = useState({ type: 'CHEQUE' })

  useEffect(() => { setMutationVariables(!_.isUndefined(payment) ? { ..._.omit(payment, ['shippings', '__typename', 'withHoldingTax']) } : { type: 'CHEQUE' }) }, [payment])
  return (
    <Modal
      title="แก้ไขการจ่ายเงิน"
      visible={paymentModal}
      destroyOnClose={true}
      onCancel={() => {
        setPayment(null)
        setPaymentModal(false)
        setMutationVariables({ type: 'CHEQUE' })
      }}
      onOk={() => {
        doAction({
          variables: mutationVariables,
        }).then((resp) => {
          const response = resp.data.UpdateInvoicePayment
          if (response.success) {
            message.success(response.message)
          } else message.error(response.message)
        })
        setPayment(null)
        setPaymentModal(false)
        setMutationVariables({ type: 'CHEQUE' })
      }}
      okButtonProps={{
        loading,
        disabled: loading,
      }}
      cancelButtonProps={{
        disabled: loading,
      }}
    >
      <Div display='flex' flexDirection='row' justifyContent='space-around' margin='0 0 24px'>
        <MethodButton
          onClick={() => {
            setMutationVariables({
              ...mutationVariables,
              type: 'CHEQUE',
            })
          }}
          bg={mutationVariables.type === 'CHEQUE'}
        >เช็ค</MethodButton>
        <MethodButton
          onClick={() => {
            setMutationVariables({
              ...mutationVariables,
              type: 'TRANSFER',
            })
          }}
          bg={mutationVariables.type === 'TRANSFER'}
        >โอนเงิน</MethodButton>
      </Div>
      <Div>
        <Div display='flex' flexDirection='row' margin='0 0 16px'>
          {/* paidDate */}
          <Col span={8}>
            <P>วันที่รับชำระเงิน *</P>
          </Col>
          <Col span={16}>
            <DP format='DD/MM/YYYY'
              value={moment(mutationVariables.paidDate)}
              disabled={true}
              onChange={e => setMutationVariables({
                ...mutationVariables,
                paidDate: e,
              })} />
          </Col>
        </Div>
        <Div display='flex' flexDirection='row' margin='0 0 16px'>
          {/* bank */}
          <Col span={8}>
            <P>ธนาคาร *</P>
          </Col>
          <Col span={16}>
            <Select
              dropdown
              showSearch
              style={{ width: 316 }}
              value={mutationVariables.bank}
              onChange={e => setMutationVariables({
                ...mutationVariables,
                bank: e,
              })}
              disabled={true}
            >
              {
                invoice?.InvoiceInfo?.Job?.companyType === 'PADOONGRICH'
                  ? PDRBankList.map(v => !_.isNull(v.text) && <Select.Option key={v.text} value={v.code}>{v.text}</Select.Option>)
                  : TRSBankList.map(v => !_.isNull(v.text) && <Select.Option key={v.text} value={v.code}>{v.text}</Select.Option>)
              }
            </Select>
          </Col>
        </Div>
        <Div display='flex' flexDirection='row' margin='0 0 16px'>
          {/* bankNumber chequeNumber */}
          <Col span={8}>
            <P>เลขที่ *</P>
          </Col>
          <Col span={16}>
            <Input width='100%'
              value={mutationVariables.type === 'CHEQUE' ? mutationVariables.chequeNumber : mutationVariables.bankNumber}
              onChange={(e) => {
                if (mutationVariables.type === 'CHEQUE') {
                  setMutationVariables({
                    ...mutationVariables,
                    chequeNumber: e.target.value,
                  })
                } else {
                  setMutationVariables({
                    ...mutationVariables,
                    bankNumber: e.target.value,
                  })
                }
              }}
            />
          </Col>
        </Div>
        {
          mutationVariables.type === 'CHEQUE'
          && <Div display='flex' flexDirection='row' margin='0 0 16px'>
            {/* chequeDate */}
            <Col span={8}>
              <P>วันที่หน้าเช็ค *</P>
            </Col>
            <Col span={16}>
              <DP
                format='DD/MM/YYYY'
                value={moment(mutationVariables.chequeDate)}
                onChange={e => setMutationVariables({
                  ...mutationVariables,
                  chequeDate: e,
                })}
              />
            </Col>
          </Div>
        }
      </Div>
    </Modal>
  )
}

export const PaidInfo = ({
  invoice, isViewMode,
}) => {
  const [paymentModal, setPaymentModal] = useState(false)
  const [paymentShippingInfoModal, setPaymentShippingInfoModal] = useState(false)
  const [payment, setPayment] = useState()
  const [shipping, setShipping] = useState()

  const taxList = [
    { value: 0, text: '0' },
    { value: 0.5, text: '0.5' },
    { value: 0.75, text: '0.75' },
    { value: 1, text: '1' },
    { value: 2, text: '2' },
    { value: 3, text: '3' },
    { value: 5, text: '5' },
    { value: 10, text: '10' },
    { value: 15, text: '15' },
  ]
  let isCheque

  return (
    <Div display='flex' flexDirection='column'>
      <Mutation
        mutation={UPDATE_INVOICE_PAYMENT}
        refetchQueries={['InvoiceInfo']}
      >{(doAction, { loading }) => (
        <Div display='flex' flexDirection='column'>
          <H4 bold margin='24px 0 0'>รายละเอียดการชำระเงิน</H4>
          {
            _.map(invoice.InvoiceInfo.payment, (v, i) => {
              isCheque = !_.isNull(v.chequeNumber) && !_.isUndefined(v.chequeNumber) && !_.isEmpty(v.chequeNumber)
              return (
                <Div display='flex' flexDirection='column' justifyContent='flex-start' padding='32px 0 40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}>
                  <Div display='flex' flexDirection='row' justifyContent='space-between' margin='0 0 16px'>
                    <P bold>ครั้งที่ {i + 1}</P>
                    <Div display='flex' flexDirection='row'>
                      <Button
                        margin='0 0 0 16px'
                        disabled={!_.includes(window.perms, PERMISSION.RECEIVE_PAYMENT_INVOICE)}
                        text='แก้ไขการจ่ายเงิน'
                        onClick={() => {
                          setPaymentModal(true)
                          setPayment(v)
                        }}
                      />
                    </Div>
                  </Div>
                  <Row type='flex' style={{ flexWrap: 'nowrap', minWidth: 800, margin: '0 0 16px' }}>
                    <Div display='flex' flexDirection='column' width='20%'>
                      <P margin='0 0 16px'>วันที่รับชำระ</P>
                      <P>{moment(v.paidDate).format('DD-MM-YYYY')}</P>
                    </Div>
                    <Div display='flex' flexDirection='column' width='20%'>
                      <P margin='0 0 16px'>ธนาคาร</P>
                      <P>{v.bank}</P>
                    </Div>
                    <Div display='flex' flexDirection='column' width='20%'>
                      <P margin='0 0 16px'>{isCheque ? 'หมายเลขเช็ค' : 'หมายเลขธนาคาร'}</P>
                      <P>
                        {
                          isCheque
                            ? v.chequeNumber
                            : v.bankNumber
                        }
                      </P>
                    </Div>
                    {
                      (isCheque)
                      && <Div display='flex' flexDirection='column' width='20%'>
                        <P margin='0 0 16px'>วันที่หน้าเช็ค</P>
                        <P>{moment(v.chequeDate).format('DD-MM-YYYY')}</P>
                      </Div>
                    }
                    <Div display='flex' flexDirection='column' width='20%'>
                      <P margin='0 0 16px'>จำนวนเงิน</P>
                      <P>{v.grandTotal} บาท</P>
                    </Div>
                  </Row>
                  <Row type='flex' style={{ flexWrap: 'nowrap', minWidth: 800, margin: '0 0 16px' }}>
                    <Div display='flex' flexDirection='column' width='20%'>
                      <P margin='0 0 16px'>หัก ณ ที่จ่าย</P>
                      <P>{_.isNull(v.withHoldingTax) ? 0 : v.withHoldingTax} %</P>
                    </Div>
                    <Div display='flex' flexDirection='column' width='20%'>
                      <P margin='0 0 16px'>ยอดเงินหัก ณ ที่จ่าย</P>
                      <P>{v.amountWithHeld || 0} บาท</P>
                    </Div>
                    <Div display='flex' flexDirection='column' width='20%'>
                      <P margin='0 0 16px'>ค่าธรรมเนียมที่ลูกค้าจ่าย</P>
                      <P>{v.customerBankFees || 0} บาท</P>
                    </Div>
                    <Div display='flex' flexDirection='column' width='20%'>
                      <P margin='0 0 16px'>ค่าธรรมเนียมที่ผดุงฤทธิ์จ่าย</P>
                      <P>{v.pdrBankFees || 0} บาท</P>
                    </Div>
                    <Div display='flex' flexDirection='column' width='20%'>
                      <P margin='0 0 16px'>ส่วนลดน้ำหนักขาด</P>
                      <P>{v.lostWeightFee || 0} บาท</P>
                    </Div>
                  </Row>
                  <Row type='flex' style={{ flexWrap: 'nowrap', minWidth: 800, margin: '0 0 16px' }}>
                    <Div display='flex' flexDirection='column' width='20%'>
                      <P margin='0 0 16px'>ค่าปรับส่งตั๋วล่าช้า</P>
                      <P>{v.lateTicketFee || 0} บาท</P>
                    </Div>
                    <Div display='flex' flexDirection='column' width='20%'>
                      <P margin='0 0 16px'>ค่าสินค้าชำรุดเสียหาย</P>
                      <P>{v.damagedGoodFee || 0} บาท</P>
                    </Div>
                    <Div display='flex' flexDirection='column' width='20%'>
                      <P margin='0 0 16px'>ค่าส่วนลดรับ</P>
                      <P>{v.discountFee || 0} บาท</P>
                    </Div>
                    <Div display='flex' flexDirection='column' width='20%'>
                      <P margin='0 0 16px'>ค่าส่วนเกิน/ส่วนขาดจากการชำระหนี้</P>
                      <P>{v.excessPaymentFee || 0} บาท</P>
                    </Div>
                    <Div display='flex' flexDirection='column' width='20%'>
                      <P margin='0 0 16px'>ค่าเสียหายจากอุบัติเหตุ</P>
                      <P>{v.accidentFee || 0} บาท</P>
                    </Div>
                  </Row>
                  <Row type='flex' style={{ flexWrap: 'nowrap', minWidth: 800, margin: '0 0 16px' }}>
                    <Div display='flex' flexDirection='column' width='20%'>
                      <P margin='0 0 16px'>เงินจ่ายล่วงหน้า - เงินประกัน</P>
                      <P>{v.lostInsuranceFee || 0} บาท</P>
                    </Div>
                    <Div display='flex' flexDirection='column' width='20%'>
                      <P bold margin='0 0 16px'>ยอดสุทธิ</P>
                      <P bold>{v.amountReceived} บาท</P>
                    </Div>
                  </Row>
                  <Collapse>
                    <Panel header="ดูรายละเอียดใบสั่งบรรทุก" key="1">
                      <ShippingLog data={{
                        ...v,
                        jobDealType: invoice.InvoiceInfo.Job.dealType,
                        jobUnit: invoice.InvoiceInfo.Job.unit,
                        isMithrGroup: invoice.InvoiceInfo.Job.Customer.groupId === 6,
                      }} />
                    </Panel>
                  </Collapse>
                </Div>
              )
            })
          }
          <EditPaymentModal
            payment={payment}
            paymentModal={paymentModal}
            setPaymentModal={setPaymentModal}
            doAction={doAction}
            loading={loading}
            setPayment={setPayment}
            invoice={invoice}
          />
        </Div>
      )
        }
      </Mutation>
    </Div >
  )
}

export const ShippingLog = ({
  data, update,
}) => {
  const convertUnit = (unit) => {
    switch (unit) {
      case 'TON': return 'ตัน'
      case 'KG': return 'กิโลกรัม'
      case 'H50': return 'กระสอบ50'
      case 'TRIP': return 'เที่ยว'
      // case 'H60': return 'กระสอบ60'
      // case 'H100': return 'กระสอบ100'
      default: return 'หน่วย'
    }
  }
  return (
    <Div display='flex' flexDirection='column' flexWrap='nowrap' style={{ overflow: 'auto' }}>
      <Row type='flex' gutter={4} style={{ margin: '32px 0', flexWrap: 'nowrap', minWidth: 800 }}>
        {/* <Col span={1} style={{ textAlign: 'center' }}></Col> */}
        <Col span={2} style={{ textAlign: 'center' }}><P bold>เล่มที่</P></Col>
        <Col span={1} style={{ textAlign: 'center' }}><P bold>เลขที่</P></Col>
        <Col span={2} style={{ textAlign: 'center' }}><P bold>วันที่นำส่ง</P></Col>
        <Col span={3} style={{ textAlign: 'center' }}><P bold>เลขที่ใบนำส่ง</P></Col>
        <Col span={3} style={{ textAlign: 'center' }}><P bold>ทะเบียนรถ</P></Col>
        <Col span={2} style={{ textAlign: 'center' }}><P bold>น้ำหนักต้นทาง</P></Col>
        <Col span={2} style={{ textAlign: 'center' }}><P bold>น้ำหนักปลายทาง</P></Col>
        <Col span={2} style={{ textAlign: 'center' }}><P bold>น้ำหนักขาดเกิน</P></Col>
        <Col span={2} style={{ textAlign: 'center' }}><P bold>ราคา/{data.jobDealType === 'PERTRIP' ? 'เที่ยว' : convertUnit(data.shippings[0].unit)}</P></Col>
        <Col span={2} style={{ textAlign: 'center' }}><P bold>น้ำหนักสุทธิ</P></Col>
        <Col span={2} style={{ textAlign: 'center' }}><P bold>ค่าขนส่ง (บาท)</P></Col>
      </Row>
      <Mutation
        mutation={REMOVE_SHIPPING_ORDER_FROM_INVOICE}
        refetchQueries={['InvoiceInfo', 'calculateDeliveredShipping']}
      >
        {(doRemove, { loading }) => (
          _.map(data.shippings, v => <Row type='flex' style={{ flexWrap: 'nowrap', minWidth: 800 }}>
            <Col span={2} style={{
              margin: '0 0 16px', display: 'flex', justifyContent: 'center', alignItems: 'center',
            }}><P>{_.isEmpty(v.shippingVolume) ? '-' : v.shippingVolume}</P></Col>
            <Col span={1} style={{
              margin: '0 0 16px', display: 'flex', justifyContent: 'center', alignItems: 'center',
            }}><P>{_.isEmpty(v.shippingNumber) ? '-' : v.shippingNumber}</P></Col>
            <Col span={2} style={{
              margin: '0 0 16px', display: 'flex', justifyContent: 'center', alignItems: 'center',
            }}><P>{_.isEmpty(v.deliveryDate) ? '-' : moment(v.deliveryDate).format('DD/MM/YYYY')}</P></Col>
            <Col span={3} style={{
              margin: '0 0 16px', display: 'flex', justifyContent: 'center', alignItems: 'center',
            }}><P>{_.isEmpty(v.weightRecordId) ? '-' : v.weightRecordId}</P></Col>
            <Col span={3} style={{
              margin: '0 0 16px', display: 'flex', justifyContent: 'center', alignItems: 'center',
            }}><P>{_.isUndefined(v.Truck) || _.isNull(v.Truck) ? '-' : v.Truck.plateNumber}/{_.isUndefined(v.Trailer) || _.isNull(v.Trailer) ? '-' : v.Trailer.trailerPlate}</P></Col>
            <Col span={2} style={{
              margin: '0 0 16px', display: 'flex', justifyContent: 'center', alignItems: 'center',
            }}><P>{_.isNull(v.startWeight) ? '-' : v.startWeight}</P></Col>
            <Col span={2} style={{
              margin: '0 0 16px', display: 'flex', justifyContent: 'center', alignItems: 'center',
            }}><P>{_.isNull(v.endWeight) ? '-' : v.endWeight}</P></Col>
            <Col span={2} style={{
              margin: '0 0 16px', display: 'flex', justifyContent: 'center', alignItems: 'center',
            }}><P>{_.isNull(v.weightDifference) ? '-' : v.weightDifference}</P></Col>
            <Col span={2} style={{
              margin: '0 0 16px', display: 'flex', justifyContent: 'center', alignItems: 'center',
            }}><P>{_.isNull(v.feeRate) ? '-' : v.feeRate}</P></Col>
            <Col span={2} style={{
              margin: '0 0 16px', display: 'flex', justifyContent: 'center', alignItems: 'center',
            }}><P>{_.isNull(v.totalWeight) ? '-' : v.totalWeight}</P></Col>
            <Col span={2} style={{
              margin: '0 0 16px', display: 'flex', justifyContent: 'center', alignItems: 'center',
            }}><P>{_.isNull(v.feeTotal) ? '-' : data.isMithrGroup ? v.feeTotal.toFixed(3) : v.feeTotal.toFixed(2)}</P></Col>
            {update
              && <Col span={2} style={{ margin: '0 0 16px' }}>
                <Button
                  loading={loading}
                  disabled={loading}
                  text={'ลบรายการนี้'}
                  icon={'fas fa-delete'}
                  onClick={() => {
                    Modal.confirm({
                      title: `คุณต้องการลบใบสั่งบรรทุกเล่มที่ ${_.isEmpty(v.shippingVolume) ? '-' : v.shippingVolume} เลขที่ ${_.isEmpty(v.shippingNumber) ? '-' : v.shippingNumber} จากใบวางบิลนี้`,
                      cancelText: 'เก็บไว้',
                      okText: 'ลบใบสั่งบรรทุก',
                      onCancel() {
                      },
                      onOk() {
                        doRemove({
                          variables: {
                            shippingId: v.id,
                            invoiceId: data.id,
                          },
                        }).then((res) => {
                          if (res.data.RemoveShippingorderFromInvoice.success) {
                            message.success(res.data.RemoveShippingorderFromInvoice.message)
                          } else message.error(res.data.RemoveShippingorderFromInvoice.message)
                        })
                      },
                    })
                  }}
                  small
                  color={color.error}
                />
              </Col>
            }
          </Row>)
        )}
      </Mutation>
    </Div>
  )
}

export default PaidInfo
